import { Link } from "react-router-dom";
import { FaChevronRight, FaHouse } from "react-icons/fa6";
import { useTranslation } from "react-i18next";


const Breadcrumb = ({ items = [] }) => {
  const { t } = useTranslation();

  return (

    <div className="w-full overflow-x-auto py-2">
      <nav className="
    bg-card
    border border-border
    shadow-main
    rounded-xl
    px-4 py-2
    mb-4    
    font-semibold flex items-center gap-2 w-full max-w-full overflow-x-auto whitespace-nowrap text-text text-base">
        <Link
          to="/"
          className="flex items-center gap-1 hover:text-primary px-1 transition font-medium"
          tabIndex={0}
          aria-label={t("breadcrumb.home")}
        >
          <FaHouse className="w-5 h-5" />
          <span className="hidden sm:inline">{t("breadcrumb.home")}</span>

        </Link>
        {items.length > 0 && (
          <FaChevronRight className="inline-block w-4 h-4 text-menu mx-1" />
        )}

        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <span key={item.path || idx} className="flex items-center">
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="hover:text-primary text-text2 px-1 transition font-medium"
                  tabIndex={0}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`
                  font-bold text-primary px-1
                  ${isLast ? "truncate max-w-[120px] block sm:max-w-none" : ""}
                `}
                  aria-current="page"
                  title={item.label}
                >
                  {item.label}
                </span>
              )}
              {idx < items.length - 1 && (
                <FaChevronRight className="inline-block w-4 h-4 text-menu mx-1" />
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
}
export default Breadcrumb;
